export default __webpack_public_path__ + "static/media/icon_location_active.d9c76ff9.svg";